// @flow

import {
  AFTER_NEXT_QUESTION,
  EDIT_QUESTION,
  NEXT_QUESTION,
  PRE_EDIT_QUESTION,
  UPDATE_FIELD_VALUE,
} from './CostCalculatorForm.constants';

export default (state, action) => {
  switch (action.type) {
    case UPDATE_FIELD_VALUE: {
      const question = state.questions.find(q => q.fieldName === action.fieldName);

      const newQuestions = state.questions.map(q => {
        if (q.fieldName === question.fieldName) {
          return { ...q, fieldValue: action.fieldValue };
        }
        return q;
      });

      return { ...state, questions: newQuestions };
    }
    case NEXT_QUESTION: {
      const newQuestions = state.questions.map(q => {
        if (q.index === state.currentQuestionIndex) {
          return { ...q, isAnswered: true };
        }
        return q;
      });

      return {
        ...state,
        currentQuestionIndex: action.nextIndex,
        questions: newQuestions,
        isAfterNext: false,
      };
    }
    case AFTER_NEXT_QUESTION: {
      return { ...state, isAfterNext: true };
    }
    case PRE_EDIT_QUESTION: {
      return { ...state, isPreEdit: true, preEditQuestionIndex: action.index };
    }
    case EDIT_QUESTION: {
      const newQuestions = state.questions.map(q => {
        const { fieldValue, isAnswered, ...rest } = q;

        if (q.index === action.index) {
          return { ...q, isAnswered: false };
        }
        if (q.index > action.index) {
          return { ...rest, isAnswered: false };
        }
        return q;
      });

      return {
        ...state,
        currentQuestionIndex: action.index,
        isPreEdit: false,
        questions: newQuestions,
      };
    }
    default:
      return state;
  }
};
